import { ChangelogCountResponse, ChangelogEntry, ChangelogRequest, ChangelogResponse } from '@uptime-bff/api-contract';
import { uptimeApi, TagTypes } from 'core/api';

const changelogApi = uptimeApi.injectEndpoints({
  endpoints: (build) => ({
    searchChangelog: build.query<ChangelogResponse[], ChangelogRequest>({
      query: (body) => ({
        url: 'changelog',
        method: 'POST',
        body,
      }),
      providesTags: [TagTypes.Changelog],
    }),
    postChangelogCount: build.query<ChangelogCountResponse, ChangelogRequest>({
      query: (body) => ({
        url: 'changelog/unread-count',
        method: 'POST',
        body,
      }),
      providesTags: [TagTypes.Changelog],
    }),
    postReadChangelog: build.mutation<void, { changelogId: string }>({
      query: (body) => ({
        url: `changelog/read/${body.changelogId}`,
        method: 'POST',
        body,
      }),
    }),
    postWhatIsNew: build.query<ChangelogEntry[], ChangelogRequest>({
      query: (body) => ({
        url: 'changelog/what-is-new',
        method: 'POST',
        body,
      }),
      providesTags: [TagTypes.Changelog],
    }),
  }),
});

export const {
  useLazySearchChangelogQuery,
  usePostChangelogCountQuery,
  usePostReadChangelogMutation,
  usePostWhatIsNewQuery,
} = changelogApi;
